import { ButtonSecondary, IconInstagram, IconTwitter, cssColorValue, screenSmMax, spacer16, } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
const Column = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0px;
  gap: ${spacer16};
  flex: none;
  order: 4;
  align-self: stretch;
  flex-grow: 1;
  width: calc(24% - 16px);
  @media (max-width: ${screenSmMax}) {
    order: 2;
    align-items: flex-start;
    width: 100%;
  }
`;
const SocialContainer = styled.div `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: ${spacer16};
`;
const StyledButtonSecondary = styled(ButtonSecondary) `
  color: ${props => { var _a, _b; return (_b = (_a = props.colors) === null || _a === void 0 ? void 0 : _a.primaryText) !== null && _b !== void 0 ? _b : cssColorValue('textBase'); }} !important;

  &:hover {
    border-color: ${props => { var _a, _b; return (_b = (_a = props.colors) === null || _a === void 0 ? void 0 : _a.primaryText) !== null && _b !== void 0 ? _b : cssColorValue('textBase'); }};
  }
`;
export const FooterSocial = ({ colors }) => {
    return (React.createElement(Column, null,
        React.createElement(SocialContainer, null,
            React.createElement(StyledButtonSecondary, { href: "https://twitter.com/spotifyartists", target: "_blank", "data-testid": "footer-twitter", iconOnly: IconTwitter, "aria-label": "Twitter", colors: colors }),
            React.createElement(StyledButtonSecondary, { "data-testid": "footer-instagram", target: "_blank", href: "https://www.instagram.com/spotifyforartists/", iconOnly: IconInstagram, "aria-label": "Instagram", colors: colors }))));
};
//# sourceMappingURL=Social.js.map